





































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import IdentitasPasienRingkas from "./IdentitasPasienRingkas.vue";
import PembatalanSvc from "@/services/PembatalanKomponenDarah";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { prefillRuangRawat } from "@/utils/prefillBangsalKelas";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";
import {
  ALASAN_PEMBATALAN_OPSI,
  KantongTersedia,
  PembatalanForm,
  PembatalanKomponenDarah,
  PembatalanStatus,
  STATUS_PEMBATALAN_WARNA
} from "@/types/pembatalan_komponen_darah";

@Component({
  components: { CardModalTtd, VCDateTimePicker, IdentitasPasienRingkas },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PembatalanKomponenDarahList extends Vue {
  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

  isReadOnly!: () => boolean;

  readonly alasanOpsi = ALASAN_PEMBATALAN_OPSI;

  items: PembatalanKomponenDarah[] = [];
  loading = false;
  dialogForm = false;
  aktif: PembatalanKomponenDarah | null = null;
  form: PembatalanForm = this.formKosong();
  kantongItems: KantongTersedia[] = [];
  terpilih: KantongTersedia[] = [];
  memuatKantong = false;
  saving = false;
  simpanTtd = false;
  modalTtd = false;
  signItem: PembatalanKomponenDarah | null = null;
  dialogBerhasil = false;
  dialogHapus = false;
  hapusItem: PembatalanKomponenDarah | null = null;
  deleting = false;

  readonly headers = [
    { text: "Tgl / Jam", value: "dibatalkan_at", width: "130px" },
    { text: "Kantong", value: "kantong", sortable: false },
    { text: "Jml", value: "jumlah_kantong", width: "50px", align: "center" },
    { text: "Alasan", value: "alasan", sortable: false },
    { text: "Status", value: "status", width: "140px", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "110px" }
  ];

  readonly headersKantong = [
    { text: "No Kantong", value: "kode_kantong" },
    { text: "Jenis Komponen Darah", value: "label_komponen" },
    { text: "Golongan Darah", value: "label_golongan" },
    { text: "Hasil", value: "hasil_nomor" }
  ];

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get userId(): number | null {
    return userModule.user ? userModule.user.id : null;
  }

  get terkunci(): boolean {
    return this.readOnly || !!(this.aktif && !this.bisaUbah(this.aktif));
  }

  get jumlahKantong(): number {
    return this.terkunci && this.aktif ? this.aktif.jumlah_kantong : this.terpilih.length;
  }

  get dibatalkanAt(): Date | null {
    const v = this.form.dibatalkan_at;
    return v ? composeDate(v.slice(0, 10), v.slice(11, 16)) : null;
  }

  set dibatalkanAt(val: Date | null) {
    this.form.dibatalkan_at = val ? `${toDateString(val)} ${toTimeString(val)}:00` : null;
  }

  mounted() {
    this.muat();
  }

  @Watch("register")
  onRegister() {
    this.dialogForm = false;
    this.muat();
  }

  formKosong(): PembatalanForm {
    return {
      id: null,
      dibatalkan_at: moment().format("YYYY-MM-DD HH:mm:00"),
      alasan: null,
      ruang: null,
      kantong_ids: []
    };
  }

  warna(status: PembatalanStatus): string {
    return STATUS_PEMBATALAN_WARNA[status] || "blue-grey";
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  bisaUbah(item: PembatalanKomponenDarah): boolean {
    return (
      !this.readOnly &&
      item.status === "draft" &&
      String(item.creator_user_id) === String(this.userId)
    );
  }

  alasanTidakBisaHapus(item: PembatalanKomponenDarah): string {
    if (this.readOnly) return "Kunjungan sudah terkunci";
    if (item.status === "disetujui") return "Sudah disetujui Bank Darah, tidak dapat dihapus";
    if (String(item.creator_user_id) !== String(this.userId)) {
      return "Hanya pembuat pembatalan yang dapat menghapus";
    }
    return "";
  }

  async muat() {
    if (!this.register) return;
    const register = this.register;
    this.loading = true;
    try {
      const data = await PembatalanSvc.getByRegister(register);
      if (String(register) === String(this.register)) this.items = data;
    } catch {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  async muatKantong(kecuali: number | null) {
    this.memuatKantong = true;
    try {
      this.kantongItems = await PembatalanSvc.kantongTersedia(this.register, kecuali);
    } catch {
      this.kantongItems = [];
    } finally {
      this.memuatKantong = false;
    }
  }

  async bukaForm(item: PembatalanKomponenDarah | null) {
    this.aktif = item;

    if (item) {
      this.form = {
        id: item.id,
        dibatalkan_at: item.dibatalkan_at,
        alasan: item.alasan,
        ruang: item.ruang,
        kantong_ids: item.kantong.map(k => k.hasil_pemeriksaan_darah_kantong_id)
      };
    } else {
      this.form = {
        ...this.formKosong(),
        ruang: prefillRuangRawat(RegisterKunjungan.register as any, this.register) || null
      };
    }

    this.dialogForm = true;
    this.terpilih = [];

    if (item && !this.bisaUbah(item)) {
      this.kantongItems = item.kantong.map(k => ({
        id: k.hasil_pemeriksaan_darah_kantong_id,
        kode_kantong: k.kode_kantong || "",
        komponen: k.komponen,
        komponen_lain: null,
        label_komponen: k.label_komponen,
        gol_darah: k.gol_darah,
        rhesus: k.rhesus,
        label_golongan: k.label_golongan,
        hasil_id: 0,
        hasil_nomor: null,
        hasil_jenis: ""
      }));
      return;
    }

    await this.muatKantong(item ? item.id : null);
    const ids = this.form.kantong_ids;
    this.terpilih = this.kantongItems.filter(k => ids.indexOf(k.id) >= 0);
  }

  cekIsian(): string | null {
    const kurang: string[] = [];
    if (!this.form.dibatalkan_at) kurang.push("Tanggal & Jam Pembatalan");
    if (!this.terpilih.length) kurang.push("Kantong yang dibatalkan");
    if (!this.form.alasan || !String(this.form.alasan).trim()) kurang.push("Alasan Pembatalan");
    return kurang.length ? "Lengkapi dulu: " + kurang.join(", ") + "." : null;
  }

  async simpan(tandatangani: boolean) {
    if (this.saving) return;

    const kurang = this.cekIsian();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    this.saving = true;
    this.simpanTtd = tandatangani;
    try {
      const res = await PembatalanSvc.simpan(this.register, {
        ...this.form,
        alasan: String(this.form.alasan).trim(),
        kantong_ids: this.terpilih.map(k => k.id)
      });
      appModule.sendSuccessNotice(res.message);
      this.dialogForm = false;
      await this.muat();
      if (tandatangani && res.data) this.bukaTtd(res.data);
    } catch {
      return;
    } finally {
      this.saving = false;
      this.simpanTtd = false;
    }
  }

  bukaTtd(item: PembatalanKomponenDarah) {
    this.signItem = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;
    try {
      await PembatalanSvc.sign(this.signItem.id, password);
      this.modalTtd = false;
      this.signItem = null;
      appModule.addMsgTtd("");
      this.dialogBerhasil = true;
      this.muat();
    } catch {
      this.modalTtd = true;
    }
  }

  konfirmHapus(item: PembatalanKomponenDarah) {
    this.hapusItem = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusItem || this.deleting) return;
    this.deleting = true;
    try {
      const res = await PembatalanSvc.destroy(this.hapusItem.id);
      appModule.sendSuccessNotice(res.message);
      this.dialogHapus = false;
      this.hapusItem = null;
      this.muat();
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }
}
